import { render, staticRenderFns } from "./PromoKeyboardModal.vue?vue&type=template&id=45e41595&scoped=true"
import script from "./PromoKeyboardModal.vue?vue&type=script&lang=js"
export * from "./PromoKeyboardModal.vue?vue&type=script&lang=js"
import style0 from "./PromoKeyboardModal.vue?vue&type=style&index=0&id=45e41595&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45e41595",
  null
  
)

export default component.exports